var React = require('react');

function Italic (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M208 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M158.75 96h82.5l-80 320h-82.5z","className":"fa-primary","key":2})]);
}

Italic.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = Italic;

Italic.default = Italic;
